import React, { useEffect, useState } from 'react'
import Fetch from './fetch.js';
import { ToggleControl } from '@wordpress/components';
import MaintenancePage from './MaintenancePage';
import { Button } from '@wordpress/components'

function MaintenanceMode() {

    const [maintenanceMode, setMode] = useState(false)
    const [maintenancePage, setPage] = useState('')
    useEffect(() => {
        async function loadMode() {
            const response = await fetch('/wp-json/davenport/v1/maintenance_mode');
            if(!response.ok) {
                return;
            }
    
            const modeOpt = await response.json();
            setMode(modeOpt.mode)
            setPage(modeOpt.page)
        }
    
        loadMode();
        
    }, [])

    const saveMaintenanceMode = ( event ) => {
        
        let inputs = JSON.stringify({"mode":maintenanceMode,"page":maintenancePage})
        
        let params = {
        	url : DBD.api_maintenance_mode.url,
        	nonce : DBD.api_maintenance_mode.nonce,
        	action : 'save_maintenance_mode',
        	data : inputs,
        };
                
        Fetch.send(params,function(message){
            localStorage.setItem('active-tab','maintenance-mode');
            location.reload();
        });
    }

    return(
            <>
                <ToggleControl
                    label="Maintenance Mode"
                    help={
                        maintenanceMode
                            ? 'ON'
                            : 'OFF'
                    }
                    checked={ maintenanceMode }
                    onChange={ () => {
                        setMode( ( state ) => ! state );
                    } }
                />
            
            <MaintenancePage page={maintenancePage} handlePageChange={setPage} />
            <Button 
                className="btn btn-primary sm save-maintenance" 
                onClick={(e) => {saveMaintenanceMode(e)}}
            >
                Save
            </Button>
        </>
    );

}

export default MaintenanceMode